import { render, staticRenderFns } from "./AdminQuestion_edit_2.vue?vue&type=template&id=7b3ed607&"
import script from "./AdminQuestion_edit_2.vue?vue&type=script&lang=js&"
export * from "./AdminQuestion_edit_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports